module.exports = __webpack_public_path__ + "static/media/B3.bfc33655.jpg";